exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead,\ntbody {\n  display: block; }\n\ntbody {\n  overflow: scroll;\n  height: calc(100vh - 225px); }\n\n.col-check {\n  width: 50px; }\n\n.col-design {\n  width: 250px; }\n\n.col-size {\n  width: 100px; }\n\n.col-color {\n  width: 150px; }\n\n.col-barcode {\n  width: 150px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/ViewReprintBarcode/viewReprintBarcode.scss
// module id = ../../../../../src/app/components/master/ViewReprintBarcode/viewReprintBarcode.scss
// module chunks = main